<template>
  <div class="filter-box">
    <div class="title" :style="titleConfig.id ? 'cursor:pointer' : ''" @click="selectItem(titleConfig)">{{ title }}</div>
    <template v-for="(item, key) in list">
      <div
        :class="`list-item ${getItemClass(item)}`"
        @click="item.hasSon ? toggleItem(item) : selectItem(item)"
        :key="`item_${key}`"
      >
        <span>{{ (needTranslate ? $t(`components.filterbox.${item.name}`) : item.name)}}</span>
        <i v-if="item.hasSon" :class="item.showMore ? 'el-icon-arrow-down' : 'el-icon-plus'"></i>
      </div>
      <template v-if="item.hasSon && item.showMore">
        <div
          :class="`list-item child ${child.id == active ? 'active' : ''}`"
          v-for="(child, index) in item[labelName]"
          :key="index"
          @click="selectItem(child, true)"
        >{{needTranslate ? $t(`components.filterbox.${child.name}`) : child.name}}</div>
      </template>
    </template>
  </div>
</template>
<script>
import { deepClone } from '@/utils/index'
export default {
  props: {
    active: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    titleConfig: {
      type: Object,
      default: () => ({})
    },
    labelName: {
      type: String,
      default: 'children'
    },
    needTranslate: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getItemClass(item) {
      if (item.hasSon && item.showMore) {
        return 'hasSon showMore'
      } else if (item.hasSon) {
        return item.id === this.active ? 'active hasSon' : 'hasSon'
      } else if (item.id === this.active) {
        return 'active'
      }
    },
    async selectItem(item, isChild = false) {
      if ((!item.url && !item.id) || (item.hasSon && !item.hasArticle)) return
      if (!isChild) {
        this.list.forEach((item) => {
          item.showMore = false
        })
      }
      if (item.url) {
        this.jumpLink(item.url)
      } else {
        this.$emit('update:active', item.id)
        this.$emit('select', item.id)
      }
    },
    jumpLink(url) {
      if (url.startsWith('http')) {
        window.open(url, '_blank')
      } else {
        const { href } = this.$router.resolve({ path: url })
        window.open(href, '_blank')
      }
    },
    toggleItem(item) {
      const list = deepClone(this.list)
      const index = list.findIndex((i) => i.id === item.id)
      list.filter(i => i.id !== item.id).forEach((item) => {
        item.showMore = false
      })
      list[index].showMore = !list[index].showMore
      this.$emit('update:list', list)
      const son = item[this.labelName][0] || {}
      son.id && this.$emit('update:active', item.hasArticle ? item.id : son.id)
      son.id && this.$emit('select', item.hasArticle ? item.id : son.id)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';
.filter-box {
  width: 100%;
  background: $white;
  color: $gray-8;
  margin-bottom: 20px;
  .title {
    padding: 12px 16px;
    border-radius: 10px 10px 0 0;
    background: $light-green;
    color: $white;
    font-weight: bold;
  }
  .list-item {
    padding: 10px 16px;
    background: #efefef;
    cursor: pointer;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $white;

    &.child {
      background: #f7f7f7;
    }

    &.active {
      color: var(--primary);
    }

    &.showMore {
      color: var(--primary);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Filter/index.vue